const IMAGE_LIMIT = 9;  // 图片上传限制
const IMAGE_SIZE = 10;  // 图片大小
const IMAGE_TYPE_LIST = ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp', 'image/jp2', 'image/svg+xml'];
const IMAGE_TYPE_LIMIT = ['jpg','jepg','png','jpg2','bmp','svg'];

export default {
  install(Vue) {
    Vue.prototype.IMAGE_LIMIT = IMAGE_LIMIT,
    Vue.prototype.IMAGE_SIZE = IMAGE_SIZE,
    Vue.prototype.IMAGE_TYPE_LIST = IMAGE_TYPE_LIST,
    Vue.prototype.IMAGE_TYPE_LIMIT = IMAGE_TYPE_LIMIT
  },
}


// WEBPACK FOOTER //
// ./src/assets/js/global.js